export const formatDate = (
  date: string | null | undefined,
  format?: "long" | "short" | undefined
): string => {
  if (!date) {
    return "";
  }

  return new Date(date).toLocaleDateString(navigator.language || "lt-LT", {
    day: "2-digit",
    month: format ?? "short",
    year: "numeric",
  });
};
